export default __webpack_public_path__ + "024dab10891cdc2892f0fa69a1b99089.jpg";